import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deletedgroup } from "../../../services/admin";

export default function DeletedGroup() {
    const [rows, setRows] = useState([]);

    const columnDefs = [
        { headerName: "Group ID", field: "group_id", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Group Name", field: "group_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Total Members", field: "member_count", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Collection Day", field: "group_collection_day", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Staff", field: "staff_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Branch", field: "branch_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Center", field: "group_center", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
    ];

    useEffect(() => {
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        deletedgroup(temp).then((res) => {
            if (res.status === true) {
                setRows(res.data);
            }
        });
    }, []);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Deleted Group</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Group</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Deleted Group</li>
                </ol>
            </div>
            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Deleted Group List</h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rows}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
